import React from 'react';
import logo from './logo.svg';
import './App.css';
import Editor from './components/Editor/Editor'

function App() {
  // Retrieve the tableid if one is specified
  const params = new URLSearchParams(window.location.search);
  let tableid = params.get('tableid') || '';
  // console.log('App level. tableid', tableid);

  document.title = `Tagger V2 ${tableid}`;
  return (
    <div className="App">
      <Editor tableid={tableid}/>
    </div>
  );
}

export default App;
